import React from "react";

interface WarningMessageProps {
  message: string;
  condition: boolean;
}

const WarningMessage: React.FC<WarningMessageProps> = ({
  message,
  condition,
}) => {
  return (
    <>
      {condition ? (
        <div className="flex flex-row items-center">
          <span className="h-[14px] w-[14px] material-symbols-outlined text-text-status-red mr-[8px] flex items-center justify-center">
            warning
          </span>
          <span className="text-text-error text-[14px] text-text-status-red flex items-center">
            {message}
          </span>
        </div>
      ) : null}
    </>
  );
};

export default WarningMessage;
